/**
 * @param {number}num
 * @return {string} number as string with amount of zeroes + last two decimals e.g. 1.0435 = '
 */
export function reduceDecimals(num: number) {
  if (typeof num === 'number') {
    const numString = num.toString()
    const decimalIndex = numString.indexOf('.')
    let trailingZeroes = 0
    if (decimalIndex === -1) {
      if (num < 10) {
        return numString + '.00'
      } else {
        return numString
      }
    } else {
      if (num > 0.1) {
        return num.toFixed(2)
      }
      const test = numString.split('.')
      const tester = test[1]
      for (let i = 0; i < tester.length; i++) {
        if (tester[i] === '0') {
          trailingZeroes++
        }
        if (tester[i] !== '0') {
          break
        }
      }
      return numString.substring(0, decimalIndex + 1 + trailingZeroes + 2)
    }
  } else return ''
}
